import React from "react";
import PropTypes from "prop-types";
import { Card, Button, message, Icon, Input, Table, Select, Modal,Form, Drawer, Spin, Switch } from "antd";
import { List } from "immutable";
// import { DocumentViewer } from "../../components";
import { CaseService } from "services";
import CaseLeegalityService from "services/case-leegality-agreement-service"; 
import moment from "moment";
import { AGREEMENT_APPLICANT_DETAILS_COLS, AGREEMENT_LOGS_COLS } from "../../constants/table-columns";
import { LeegalityTemplateDrawer } from "../../modules/leegality/leegality-home";
// import axios from "axios";


const { Option } = Select;


// const {form} = Form;

// import { INPUT_TYPES, NATURE_OF_ASSOCIATION_TYPES
// } from "constants/index";
// import { OrderedMap } from "immutable";
// import CompanyService from "services/company-service";
// import _capitalize from "lodash/capitalize";

// const styles = {
//     agreementDetailKeys: { 
//         fontWeight: "700", 
//         width:"50%", 
//         background: "rgba(138, 138, 138, 0.1)" 
//     },
//     agreementDetailKeysRequired: { 
//         fontWeight: "700", 
//         width:"50%", 
//         background: "rgba(138, 138, 138, 0.1)",
//         color: "#FF808B"
//     },
//     agreementDetailValues: {
//         width:"45%",
//         marginLeft: "5%",
//         whiteSpace: "nowrap",
//         overflow: "hidden",
//         textOverflow: "ellipsis",
//         display: "flex",
//         alignItems: "center",
//         // whiteSpace: "pre-line"
//     }
// };



class Agreement extends React.Component {
    state = {
        data: new List([]),
        html: "",
        pdf: null,
        loading: true,
        status: null,
        error: "",
        is_eligible: 1,
        is_audit_trail: 0,
        audit_trail: "",
        is_initiate_active: false,
        is_signed_document: false,
        signed_document: "",
        urls: [],
        isUrlsModalVisibile: false,
        openRetriggerModal: false,
        doc: 1,
        adhocAmount: "",
        language: "",
        witness: "",
        agreementApplicantData: [],
        last_updated: "",
        total_associate: "",
        logs_data: [],
        languageList: [],
        witnessList: [],
        modalVisible : false,
        formFields: [{name:"",occupation:"",relationship:"",address:"",state:"",city:"",pincode:"",phone:""},{name:"",occupation:"",relationship:"",address:"",state:"",city:"",pincode:"",phone:""}],
        userLegailityDropdown:[],
        employeeId:"",
        finnOneId: "",
        referenceResponse:false,
        createReferenceData: [],
        isVisible: false,
        templateData: {},
        legality_data : {},
        loading : false,
        isManualSigned: {}
    }

    retriggerReason = null;

    componentDidMount() {
        this.getAgreementData(this.props.caseId, this.state.doc, 0);
        this.UserLegalityDropdown();
        this.getCreateReferenceData(this.props.caseId);
    }
    
    getCreateReferenceData = (caseId) => {
        try {
            CaseLeegalityService.getCreateReferenceData(caseId).then(({data}) => {
                this.setState({createReferenceData: [...data?.legality_relationship], referenceResponse:true});
            });
        }catch (e) {
            message.error("Error in getting data");
        }
    }

    getAgreementData = (caseId, docId, refresh) => {
        this.setState({ loading: true, error: null })

        CaseLeegalityService.getCaseAgreementData(caseId, docId, refresh ,this.state.legality_data.document_id).then((data) => {
            const applicants = data?.data?.data?.applicants_details;
            const manualSignedState = {};
            applicants?.forEach(applicant => {
                manualSignedState[applicant.id] = applicant?.is_manual_signed;
            });
            this.setState({
                legality_data: data.data.data,
                agreementApplicantData: data.data.data.applicants_details,
                isManualSigned: manualSignedState,
                last_updated: data.data.data.last_updated,
                status: data.data.data.status,
                total_associate: data.data.data.total_associate,
                logs_data: data.data.data.logs,
                signed_document: data.data.data.signed_document,
                languageList: data.data.data.document_type_detail.language,
                witnessList: data.data.data.document_type_detail.witeness
            });
        })
        .catch((error) => {
            console.error("Error is ", error);
            this.setState({ error: error.message });
          })         
          .finally(() => {
            this.setState({ loading: false });
          });
    }

    deleteRequest = () => {
        try {
            message.loading("Deleting request please wait...");
            /* eslint-disable */
           CaseLeegalityService.deleteAgreementRequest(this.props.caseId, this.state.doc, this.state.legality_data.document_id).then(()=> {
                message.success("Agreement request deleted");
                this.getAgreementData(this.props.caseId, this.state.doc, 0);
           });
        } catch (e) {
            message.error("Error in deleting request");
        }
    }

    manuallySigned = () => {
        try {
            message.loading("signing  request please wait...");
            /* eslint-disable */
           CaseLeegalityService.manuallySingedRequest(this.props.caseId, this.state.doc, this.state.legality_data.document_id).then(()=> {
                message.success("Manually signed");
                this.getAgreementData(this.props.caseId, this.state.doc, 0);
           });
        } catch (e) {
            message.error("Error in signed request");
        }
    }

    UserLegalityDropdown=()=>{
        CaseLeegalityService.getUserLegalityDropdown().then((response)=>{
            this.setState({userLegailityDropdown: response.data})

        })
    }
    
    createReference = () =>  {
            this.props.form.validateFields((err, fieldsValue) => {
                if (!err) {    
                                try{
                                    let firstFormData, secondFormData;
                                    let getFormLength =Object.keys(fieldsValue).length;
                                    if(getFormLength){
                                        firstFormData = Object.keys(fieldsValue).filter(el=>el.slice(-1) == 1).reduce((accumulator, currentValue) => {
                                            accumulator[currentValue.slice(0, -1)] = fieldsValue[currentValue];
                                            return accumulator;
                                        }, {});
                                        secondFormData = Object.keys(fieldsValue).filter(el=>el.slice(-1) == 2).reduce((accumulator, currentValue) => {
                                            accumulator[currentValue.slice(0, -1)] = fieldsValue[currentValue];
                                            return accumulator;
                                        }, {});
                                    }
                                    let finalDataToSend = getFormLength ? [firstFormData, secondFormData] : this.state.formFields;
                                message.loading("Creating Reference please wait...");      
                                CaseLeegalityService.createReference(this.props.caseId, finalDataToSend).then((res)=> {
                                message.success("Refrence details created successfully");
                                if(res.data){
                                    this.getCreateReferenceData(this.props.caseId);
                                    this.setState({referenceResponse:true, modalVisible:false})
                                }
                               })
                               .catch(function (error) {
                                console.log(error);
                              });
                             }
                                catch (e){
                                message.error("Error in Create Reference")
                                console.log("inside err", e)
                             }}
              })  
        }
    
    
    sendEmails = () => {
        try {
            message.loading("Sending email please wait...");
            /* eslint-disable */
           CaseLeegalityService.sendEmailDetails(this.props.caseId, this.state.doc).then(()=> {
                message.success("Email sent successfully");
                this.getAgreementData(this.props.caseId, this.state.doc, 0);
           });
        } catch (e) {
            message.error("Error in sending email");
        }
    }

    refresh = () => {
        this.getAgreementData(this.props.caseId, this.state.doc, 1);
    }

    triggerAgreement = () => {
        var payload = {};
        if(this.props?.caseDetail?.get('business_product_type') == 0 || this.props?.caseDetail?.get('business_product_type') == null) {
            message.error("Please Select Business Product Type");
            return 
        }
        this.props?.caseDetail?.bank_name === "IDFC FIRST Bank" && 
        CaseLeegalityService.triggerFinnOneId(this.props.caseId, this.state.finnOneId).then(()=>{
            message.success("Triggered FinnOne ID")
        })
        if(this.state.doc === 1){
            payload = {
                case_id: this.props.caseId,
                document_id: this.state.doc,
                employeeId:this.state.employeeId,
                remarks: "",
                extra_data: {
                    language: this.state.language || "Hindi"
                }
            }
        } else if(this.state.doc === 2){
            payload = {
                case_id: this.props.caseId,
                document_id: this.state.doc,
                employeeId:this.state.employeeId,
                remarks: "",
                extra_data: {
                    amount: this.state.adhocAmount
                }
            }
        } else if(this.state.doc === 3){
            payload = {
                case_id: this.props.caseId,
                document_id: this.state.doc,
                employeeId:this.state.employeeId,
                remarks: "",
                extra_data: {
                    language: this.state.language,
                    witness_id: this.state.witness
                }
            }
        }
        try {
            this.setState({
                loading : true
            })
            message.loading("Generating template please wait...");
            /* eslint-disable */
            // let hitSignzy = this.props.caseId % 10 == 9 && !this.state.legality_data.document_id && this.props.caseDetail.bank.code == "HHPL";
            let hitSignzy = false;
            CaseLeegalityService.triggerAgreement(payload , hitSignzy).then((response)=> {
                // message.success("Triggered successfully");
                this.setState({
                    templateData: response.data,
                    isVisible: hitSignzy ? true : false,
                    language: "",
                    witeness: "",
                    adhocAmount: "",
                    loading : false
                });
                this.getAgreementData(this.props.caseId, this.state.doc, 0);
           })
           .catch(() => {
                this.setState({
                    loading : false
                })
           });
        } catch (e) {
            message.error("Error in generation triggering");
            this.setState({
                loading : false
            })
        }
    }

    retriggerEsign = () => {
        message.loading("Initiating retrigger request please wait...");
        CaseService.retriggerAgreement(this.props.caseId, this.retriggerReason)
            .then(() => {
                message.success("Agreement retriggered successfully. Fetching aggreement data, please wait...");
                this.toggleRetriggerEsign();
                this.getAgreementData();
            })
            .catch(() => {});
    }

    getLogs = () => {
        return (
            <div>
                <div style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    fontSize: "14px",
                    fontWeight: "bold"
                }}>
                    Logs
                </div>
                <Table 
                    style={{border: "1px solid #e8e8e8"}} 
                    columns={AGREEMENT_LOGS_COLS} 
                    dataSource={this.state.logs_data}
                    pagination={false} 
                />
            </div> 
        );
    }

    onChangeDoc = (value) => {
        this.getAgreementData(this.props.caseId, value, 0)
        this.setState({
            doc: value,
            language: "",
            witness: "",
            adhocAmount: ""
        });
    }

    onChangeLanguage = (value) => {
        this.setState({
            language: value
        });
    }

    onChangeWitness = (value) => {
        this.setState({
            witness: value
        });
    }

    amountChange = (value) => {
        this.setState({
            [value.target.name]: value.target.value
        });
    }

    reactivateUrl = () => {
        try {
            message.loading("Reactivating expired url please wait...");
            /* eslint-disable */
           CaseLeegalityService.reinitiateAgreement(this.props.caseId, this.state.doc).then(()=> {
                message.success("Reactivated successfully");
                this.getAgreementData(this.props.caseId, this.state.doc, 0);
           });
        } catch (e) {
            message.error("Error in reactivating url");
        }
    }

    onCopyUrl = (a, record, c) => {
        var input = document.body.appendChild(document.createElement("input"));
        input.value = record.sign_url;
        input.focus();
        input.select();
        document.execCommand('copy');
        input.parentNode.removeChild(input);
        message.success("URL copied");
    }

    TableCellClick = (clickHandler, label) => (columnValue, record) => {
        return (<a onClick={clickHandler.bind(null, columnValue, record)}>{label}</a>);
    }

    TableCellCopyUrl = (clickHandler) => (columnValue, record) => {
        return (
            <span onClick={clickHandler.bind(null, columnValue, record)}>
                <Icon style={{ fontSize: '20px', cursor: "pointer" }} type="copy" />
            </span>
        );
    }

    handleChangeForm=(e, index)=>{
        const value=e.target.value;
        const fieldVal=e.target.name;
        let formFields = [ ...this.state.formFields ];
        formFields[index] = {...formFields[index], [fieldVal]: value};
        this.setState({ formFields });
    }
    triggerButtonDisable=()=>{
        if(this.props.caseDetail.bank_name==="IDFC FIRST Bank" && (this.state.employeeId=="" || this.state.referenceResponse==false || this.state.finnOneId=="")){
            return true
        }
       
        else{
            return false
        }
    }
    cancelReference=()=>{
        this.setState({modalVisible:false})
    }
    titleCase(string){
        return string[0].toUpperCase() + string.slice(1).toLowerCase();
      }
    
    formValidationRules = (el) => {
            if (el === "phone"){   
        return([
            {
                required: true,
                message: "Mobile Number is Required"
            },
            {
                min: 10,
                message: "Enter valid mobile number "
            },
            {
                max: 10,
                message: "Enter valid mobile number "
            },
            {
                pattern: /^(?:\d*)$/,
                message: "Value should contain just number",
            }]
            )} 
            if(el ==="name"){
                return([
                    {
                        max: 30,
                        message: "Max length of name is 30 characters"
                    },
                ])
            }
            if (el ==="pincode"){
                return([
                    {
                        required: true,
                        message: "Field is mandatory"
                    },
                    {
                        //eslint-disable-next-line
                        pattern: "^[1-9][0-9]{5}$",
                        message: "Enter valid Pincode"
                    }]
                )
            }
                else{
                    return(
                        [{ required: true, message: `Please input ${el}!`}]
                    )
                }
    }

    handleEsignDrawer = (refresh) => {
        if(refresh){
            this.getAgreementData(this.props.caseId, this.state.doc, 0);
           
        }
        this.setState({
            isVisible : !this.state.isVisible,
            templateData: {}
        })
    }

    previewDocument = () => {
        this.setState({
            loading: true
        })
        let payload = {}
        if(this.state.doc === 1){
            payload = {
                case_id: this.props.caseId,
                document_id: this.state.doc,
                employeeId:this.state.employeeId,
                remarks: "",
                extra_data: {
                    language: this.state.language || "Hindi"
                }
            }
        }
        const jsonData = encodeURIComponent(JSON.stringify(payload));

        window.open(`/app/preview/document?payload=${jsonData}`, '_blank');

        let hitSignzy = true;
        CaseLeegalityService.triggerAgreement(payload, hitSignzy).then((response) => {
            this.setState({
                templateData: response.data,
                isVisible: hitSignzy ? true : false,
                language: "",
                witeness: "",
                adhocAmount: "",
                loading: false
            });
        }).catch ((e)  => {
            this.setState({
                loading : false
            })
        })
    }
    onchangeManualSigned = (associate) => {
        if (this.state.isManualSigned[associate.id]) {
            message.warning("This case is already manually signed!");
            return;
        }
        const loadingMessage = message.loading("Updating...", 0);
        CaseLeegalityService.changeManualSigned(this.props.caseId, associate?.id).then(res=>{
            if (res.status === 200) {
                loadingMessage();
                this.setState(prevState => ({
                    isManualSigned: {
                        ...prevState.isManualSigned,
                        [associate.id]: true
                    }
                }));
                message.success(res?.data?.detail || "Successfully Signed!");
            }
        }).catch(err => {
            loadingMessage();
            // message.error(err.detail || "Something went wrong!");
            console.error("Error marking as manually signed:", err);
        });
    }

    render() {
        const {  form } = this.props;
        const { getFieldDecorator } = form;

        const { 
            doc, 
            adhocAmount, 
            language, 
            witness, 
            status, 
            last_updated, 
            total_associate,
            witnessList,
            languageList 
        } = this.state;
        var AGREE_COLS = AGREEMENT_APPLICANT_DETAILS_COLS;
        AGREE_COLS = AGREE_COLS.map((col, key) => {
            if(key === "action"){
                return Object.assign({
                    render: this.TableCellClick(this.reactivateUrl, "Reactivate")
                }, col);
            }
            if(key === "copy"){
                return Object.assign({
                    render: this.TableCellCopyUrl(this.onCopyUrl)
                }, col);
            }
            if(key === "is_manual_signed"){
                return Object.assign({
                    render: (_,record) => {
                        return(<Switch checked={this.state.isManualSigned[record.id]}
                             onChange={()=>this.onchangeManualSigned(record)}/>
                    )}
                }, col);
            }
            return col;
        });
        return (
            <div className={"p-10"}>
                <Spin spinning={this.state.loading}>
                {/* <LeegalityTemplateDrawer
                    showTriggerButton={false}
                    isVisible={this.state.isVisible}
                    templateData={this.state.templateData}
                    handleEsignDrawer={this.handleEsignDrawer}
                    caseId = {this.props.caseId}
                /> */}
                {this.state.is_eligible ? <div
                    style={{
                        paddingBottom: "30px",
                        background: "#eceff1",
                    }}
                >
                    <Card
                        style={{
                            padding: "50px",
                            paddingBottom: "30px",
                        }}
                    >
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <div
                                style={{
                                    display: "flex",
                                    flex: 1,
                                    alignContent: "flex-start",
                                    flexDirection: "column",
                                    lineHeight: "14px"
                                }}
                            >
                                <div>
                                    <span 
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Total Associates : {total_associate ? total_associate : "0"}
                                    </span>
                                </div>
                                <div>
                                    <span
                                        style={{
                                            fontSize: "12px",
                                            fontWeight: "normal",
                                        }}
                                    >
                                        Last Updated at <span style={{color: "#16c79a"}}>{moment(last_updated).format("MMM Do YYYY")}</span>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <div
                                    style={{
                                        lineHeight: "14px"
                                    }}
                                >
                                    <span 
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Status: <span>{status} </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div style={{marginTop: "10px"}}>
                        <div className={" mt-5 mr-15 d-flex"} style={{justifyContent: "flex-start"}}>
                                <div>
                                    <Select
                                        style={{ 
                                            width: 200,
                                            marginRight: "20px" 
                                        }}
                                        placeholder="Select"
                                        optionFilterProp="children"
                                        defaultValue={1}
                                        onChange={this.onChangeDoc}
                                        filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        <Option value={1}>PS Kit</Option>
                                        <Option value={2}>Adhoc Kit</Option>
                                        <Option value={3}>Vernacular</Option>
                                    </Select>
                                    {
                                        <Select
                                            getPopupContainer={trigger => trigger.parentNode}
                                            showSearch          
                                            placeholder="Employee name"
                                            style={{ 
                                            width: 200,
                                            marginRight: "10px",
                                        }}
                                            filterOption={(input, option) =>{
                                            return(
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            )
                                            }}
                                                >
                        
                                            { this.state.userLegailityDropdown .map(_ => (
                                                <Option onClick={()=>this.setState({employeeId:_.employee_id})} value={_.employee_id}>{_.name}</Option>
                                                ))}
                                        </Select> 
                                    }
                    
                   
                  
                                </div>
                                {
                                    doc === 1 ?
                                        <Select
                                            style={{ 
                                                width: 200,
                                                marginRight: "20px",
                                            }}
                                            placeholder="Select language"
                                            optionFilterProp="children"
                                            defaultValue={"Hindi"}
                                            onChange={this.onChangeLanguage}
                                            filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {
                                                languageList.map((item, index) => {
                                                    return <Option key={index} value={item}>{item}</Option>
                                                })
                                            }
                                        </Select>
                                        
                                        : null
                                }
                                {doc === 2 ? 
                                    <Input 
                                        placeholder="Adhoc Amount" 
                                        style={{
                                            marginRight: "10px",
                                            width: "200px",
                                        }}
                                        name={"adhocAmount"}
                                        onChange={this.amountChange}
                                    />
                                    : null
                                }
                                {
                                    doc === 3 ? 
                                        <div>
                                            <Select
                                                style={{ 
                                                    width: 200,
                                                    marginRight: "20px",
                                                }}
                                                placeholder="Select language"
                                                optionFilterProp="children"
                                                onChange={this.onChangeLanguage}
                                                filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {
                                                    languageList.map((item, index) => {
                                                        return <Option key={index} value={item}>{item}</Option>
                                                    })
                                                }
                                            </Select>
                                            <Select
                                                style={{ 
                                                    width: 200,
                                                    marginRight: "10px",
                                                }}
                                                placeholder="Select witness"
                                                optionFilterProp="children"
                                                onChange={this.onChangeWitness}
                                                filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {
                                                    witnessList.map((item, index) => {
                                                        return <Option key={index} value={item.id}>{item.name}</Option>
                                                    })
                                                }
                                            </Select>
                                            
                                            
                                        </div>
                                        : null
                                }
                                {this.props?.caseDetail?.bank_name === "IDFC FIRST Bank" && 
                                    <Input placeholder="Finn one Id" maxLength="10" style={{width:"250px"}} onChange={(e) => this.setState({finnOneId:e.target.value})}/>
                            }
                            </div>
                            <div className={"mt-5 mr-15 d-flex"} style={{justifyContent: "flex-start"}}>
                                {this.props.postSanctionPermission && <div>
                                {
                                    doc === 2 && !this.props.recreditViewOnlyPermission ? 
                                        <Button 
                                            type="primary" 
                                            icon="fire"    
                                            style={{ 
                                                background: "#16c79a", 
                                                borderColor: "#16c79a", 
                                                margin: "10px",
                                                marginLeft: "0px" 
                                            }}
                                            disabled={!adhocAmount & doc === 2 || this.triggerButtonDisable() || (!this.state.legality_data.document_id && status === "Initiated")}
                                            onClick={this.triggerAgreement}
                                        >
                                            {status === "Initiated" ? "Re-Trigger" : "Trigger"}
                                        </Button>
                                        : null
                                }
                                {
                                    doc === 3 && !this.props.recreditViewOnlyPermission ? 
                                        <Button 
                                            type="primary" 
                                            icon="fire"     
                                            style={{ 
                                                background: "#16c79a", 
                                                borderColor: "#16c79a", 
                                                margin: "10px",
                                                marginLeft: "0px"
                                            }}
                                            disabled={!(witness && language) || this.triggerButtonDisable() || (!this.state.legality_data.document_id && status === "Initiated")}
                                            onClick={this.triggerAgreement}
                                        >
                                            {status === "Initiated" ? "Re-Trigger" : "Trigger"}
                                        </Button>
                                        : null
                                }
                                {
                                    doc === 1 && !this.props.recreditViewOnlyPermission ? 
                                        <Button 
                                            type="primary" 
                                            icon="fire"  
                                            style={{ 
                                                background: "#16c79a", 
                                                borderColor: "#16c79a", 
                                                margin: "10px",
                                                marginLeft: "0px"
                                            }}
                                            onClick={this.triggerAgreement}
                                            disabled={this.triggerButtonDisable() || (!this.state.legality_data.document_id && status === "Initiated")}
                                        >
                                            {status === "Initiated" ? "Re-Trigger" : "Trigger"}
                                        </Button>
                                        : null
                                }
                                {!this.props.recreditViewOnlyPermission && <Button
                                    onClick={this.deleteRequest}
                                    type="primary" 
                                    icon="delete" 
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }}
                                    disabled={!(this.state.status === "Initiated"  && this.props.permissionContext.get("case_initiate_agreement")) }
                                >
                                    Delete Request
                                </Button> }
                                {!this.props.recreditViewOnlyPermission && <Button 
                                    type="primary" 
                                    // disabled={true} 
                                    icon={"download"} 
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }}
                                    disabled={!this.state.signed_document}
                                >
                                    <a href={this.state.signed_document} target="_blank" download > <span style={{color: "#fff!important", marginLeft: "5px"}}>Download Signed Document</span></a>
                                </Button>}
                                <Button 
                                    type="primary" 
                                    icon="reload" 
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }}
                                    onClick={this.refresh}
                                >
                                    Refresh
                                </Button>
                                {!this.props.recreditViewOnlyPermission && <Button 
                                    type="primary" 
                                    icon="mail" 
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }}
                                    onClick={this.sendEmails}
                                >
                                    Send Email
                                </Button>}
                                {!this.props.recreditViewOnlyPermission && <Button
                                    onClick={this.manuallySigned}
                                    type="primary" 
                                    icon="form" 
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }}
                                    // disabled={!(this.state.status === "Initiated"  && this.props.permissionContext.get("case_initiate_agreement")) }
                                >
                                    Marked as Manually Signed
                                </Button> }
                               { this.props.caseDetail?.bank_name==="IDFC FIRST Bank" && !this.props.recreditViewOnlyPermission &&
                               <Button
                                    onClick={() => this.setState({modalVisible:!this.state.modalVisible})}
                                    type="primary" 
                                    icon="form" 
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }
                                }
                                >
                                    Create Reference
                                </Button> 
                                  }
                                    {(this.state.doc == 1 && this.props.caseDetail?.bank?.code == "HHPL") &&
                                        <Button
                                            type="primary"
                                            icon="fire"
                                            style={{
                                                background: "#16c79a",
                                                borderColor: "#16c79a",
                                                margin: "10px",
                                                marginLeft: "0px"
                                            }}
                                            disabled={!adhocAmount & doc === 2 || this.triggerButtonDisable() || (!this.state.legality_data.document_id && status === "Initiated")}
                                            onClick={this.previewDocument}
                                        >
                                            Preview PS KIT
                                        </Button>
                                    }
                                    </div>} 
                                <Modal
                                visible={this.state.modalVisible}
                                destroyOnClose={true}
                                closable={true}
                                // onCancel={()=>this.setState({modalVisible:false})}
                                onCancel={this.cancelReference}
                                footer={[
                                <Button key="back" onClick={this.cancelReference} >
                                Cancel
                                </Button>,
                                <Button key="submit" htmlType="submit" disabled={this.props.recreditViewOnlyPermission} onClick={this.createReference}>
                                Submit
                                </Button>
                            ]}
                            >
                                 <Form
      
      autoComplete="off"
    >
        {this.state.formFields.map((formObj,index)=>{
           return( 
                <>
            <span>{`*Reference ${index+1}`}</span>
            {Object.keys(formObj).map((el,idx)=>{
                let objValue = this.state.createReferenceData.length !== 0 && this.state.createReferenceData[index];
                return (
                    <Form.Item
                    label={this.titleCase(el)} name={el}
                >
                    {getFieldDecorator(`${el+(index+1)}`, {
                        initialValue: objValue ? objValue[el] : "",
                            rules: this.formValidationRules(el),
                        })
                    (<Input name={el} onChange={(event) => this.handleChangeForm(event, index)}/>)}
                    </Form.Item>
                )
            })}
            </>
        )})} 
      </Form>
                                </Modal>
                            </div>
                        </div>
                    </Card>
                    <div style={{padding: "20px"}}>
                        <Card
                            style={{
                                borderRadius: "5px"
                            }}
                        >
                            <div>
                                <div style={{
                                    marginTop: "20px",
                                    marginBottom: "20px",
                                    fontSize: "14px",
                                    fontWeight: "bold"
                                }}>
                                    Applicant's Details
                                </div>
                                <Table 
                                    style={{border: "1px solid #e8e8e8"}} 
                                    columns={AGREE_COLS} 
                                    dataSource={this.state.agreementApplicantData}
                                    pagination={false} 
                                />
                            </div> 
                            {this.getLogs()}
                        </Card>
                    </div>
                </div>
                :   <div className={"d-flex justify-content-center"}>
                        <Icon className={"mr-5"} type={"exclamation-circle"} style={{ color: "red", fontSize: 18 }} />
                        <h2 style={{
                            textAlign: "center"
                        }}>{this.state.error}</h2>
                    </div>}
                </Spin>
            </div>
        );
    }
}


export default Form.create()(Agreement)
Agreement.propTypes = {
    history: PropTypes.object,
    permissionContext: PropTypes.object,
    caseId: PropTypes.number,
    stageId: PropTypes.number,
    caseDetail: PropTypes.object,
    company: PropTypes.object
};